import http from 'axios'
import { authApiURL as API_URL } from '../../utils'

const getSearchParams = ({ dc = null } = {}) => {
  const params = {
    action: 'getHotelSearchParams',
    dc: dc || null
  }
  return http.get(API_URL, { params }).then((res) => res.data)
}

const getSearchResults = ({ dc = null } = {}) => {
  const params = {
    action: 'getHotelSearchResults',
    dc: dc || null
  }
  return http.get(API_URL, { params }).then((res) => res.data)
}

const getCountries = ({ currency = 'EUR', dc = null } = {}) => {
  var params = {
    action: 'hotelCountries',
    currency,
    dc: dc || null
  }
  return http.get(API_URL, { params }).then((res) => res.data)
}

const getResorts = ({ country, currency = 'EUR', dc = null }) => {
  var params = {
    action: 'hotelResorts',
    country,
    currency,
    dc: dc || null
  }

  return http.get(API_URL, { params }).then((res) => res.data)
}

const getAreas = ({ country, resort, dc = null }) => {
  var params = {
    action: 'hotelAreas',
    country: country,
    resort: resort,
    dc: dc || null
  }

  return http.get(API_URL, { params }).then((res) => res.data)
}

const getHotels = ({ destination, dc = null }) => {
  var params = {
    action: 'hotels',
    destination,
    dc: dc || null
  }

  return http.get(API_URL, { params }).then((res) => res.data)
}

const search = (params) => {
  return http.post(API_URL, params, { params: { action: 'runHotelSearch' } }).then(res => res.data)
}

const paymentSchedule = (params) => {
  return http.post(API_URL, params, {
    params: {
      action: 'hotelPaymentSchedule',
      product_type: params.product_type || null
    }
  })
    .then(res => res.data)
}

const book = (params) => {
  return http.post(API_URL, params, { params: { action: 'bookHotel' } }).then((res) => res.data)
}

// this method can be used to request multiple hotels (using the "hotels" parameter)
// or single hotel (using the "hotelId" parameter)
const getHotelInfo = ({ hotels = [], hotelId, isInhouse = true }) => {
  if (!hotels.length && !hotelId) {
    throw new Error('Either "hotels" or "hotelId" parameter must be provided')
  }

  // we are trying to get info for multiple hotels
  if (hotels.length) {
    var params = {
      action: 'hotelInfo'
    }
    return http.post(API_URL, hotels, { params: params }).then((res) => {
      if (!Array.isArray(res.data))
        return [res.data]
      else return res.data
    })
  }

  // we are trying to get info for a single hotel
  var params = {
    action: 'hotelInfo',
    id: hotelId,
    is_inhouse: isInhouse ? 'yes' : 'no'
  }

  return http.get(API_URL, { params: params }).then((res) => res.data)
}

const getRoomAmenities = () => {
  const params = {
    action: 'roomAmenities'
  }
  return http.get(API_URL, { params }).then(res => res.data)
}

const getHotelAmenities = () => {
  const params = {
    action: 'hotelAmenities'
  }
  return http.get(API_URL, { params }).then(res => res.data)
}

const getHotelThemes = () => {
  const params = {
    action: 'hotelThemes'
  }
  return http.get(API_URL, { params }).then(res => res.data)
}

const getHotelTypes = () => {
  const params = {
    action: 'hotelTypes'
  }
  return http.get(API_URL, { params }).then(res => res.data)
}

export {
  getRoomAmenities,
  getHotelAmenities,
  getHotelThemes,
  getHotelTypes,
  getSearchResults,
  getSearchParams,
  getCountries,
  getResorts,
  getAreas,
  getHotelInfo,
  getHotels,
  paymentSchedule,
  search,
  book
}
